<div class="container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="toolbar">
    <button mat-icon-button (click)="snav.toggle()" class='menuButton'><mat-icon>menu</mat-icon></button>
    <h1 class="app-name"> {{AppName}} </h1>
    <img src="./../../assets/logo-blanc.png" alt="RET DE RESIDUS" title="RET DE RESIDUS" class='logo'>
    <span class="example-spacer"></span>

    <button mat-button [matMenuTriggerFor]="menu"><mat-icon>person</mat-icon> {{userName}}</button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item matTooltip='Ver perfil' color="primary" routerLink="useraccount"><mat-icon color="primary">person</mat-icon> Ver perfil</button>
      <button mat-menu-item matTooltip='Cerrar Sesión' color="primary" (click)='logout()'><mat-icon color="primary">exit_to_app</mat-icon> Cerrar sesión</button>
    </mat-menu>

  </mat-toolbar>
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav [opened]="mobileQuery.matches ? 'false' : 'true'" #snav [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches" fixedTopGap="60" fixedBottomGap="0" id="mainMenu" (click)="mobileQuery.matches && snav.toggle()">
      <mat-nav-list>
        <a mat-list-item routerLink="home" routerLinkActive="active-list-item"><mat-icon color="primary" class='listIcon'>home</mat-icon> Inicio</a>
        @if (canSeePesaje()) {
          <a mat-list-item routerLink="carga" routerLinkActive="active-list-item"><mat-icon color="primary" class='listIcon'>speed</mat-icon> Pesaje</a>
          } <!-- receipt_long -->
          @if (userRolCheck('permiso_total')) {
            <a mat-list-item routerLink="camiones" routerLinkActive="active-list-item"><mat-icon color="primary" class='listIcon'>local_shipping</mat-icon> Camiones</a>
          }
          @if (authService.canAccessContenedores()) {
            <a mat-list-item routerLink="contenedores" routerLinkActive="active-list-item"><mat-icon color="primary" class='listIcon'>inventory_2</mat-icon> Contenedores</a>
          }
          @if (userRolCheck('permiso_total')) {
            <a mat-list-item routerLink="residuos" routerLinkActive="active-list-item"><mat-icon color="primary" class='listIcon'>category</mat-icon> Residuos</a>
          }
          @if (userRolCheck('permiso_registros')) {
            <a mat-list-item routerLink="ver-registros" routerLinkActive="active-list-item"><mat-icon color="primary" class='listIcon'>source</mat-icon> Registros</a>
          }
          @if (userRolCheck('permiso_clasificar')) {
            <a mat-list-item routerLink="clasificar-registros" routerLinkActive="active-list-item"><mat-icon color="primary" class='listIcon'>fact_check</mat-icon> Clasificar</a>
          }
          <mat-divider></mat-divider>
          @if (userRolCheck('permiso_total')) {
            <a mat-list-item routerLink="settings" routerLinkActive="active-list-item"><mat-icon color="primary" class='listIcon'>settings</mat-icon> Ajustes</a>
          }
          <a mat-list-item routerLink="help" routerLinkActive="active-list-item" class="push-bottom"><mat-icon color="primary" class='listIcon'>headset_mic</mat-icon> Ayuda</a>
        </mat-nav-list>
      </mat-sidenav>
      <mat-sidenav-content class='mainContent' id="mainContent">
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
